<template>
  <ion-header v-if="sharedState">
    <ion-toolbar color="primary">
      <ion-buttons slot="end">
        <ion-button aria-label="Close policy info" @click="dismissModal()">
          <ion-icon :icon="close" slot="icon-only" aria-hidden="true"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding" :dir="direction">
    <p>For a better experience, be sure to download our app to your phone!</p>
    <download-buttons>
      <a href="https://apps.apple.com/us/app/alfredu-california/id1246525313" target="_blank" aria-label="Download on the App Store">
        <img src="/assets/img/download-app-store.svg" aria-hidden="true">
      </a>
      <a href="https://play.google.com/store/apps/details?id=org.alfredu.california" target="_blank" aria-label="Get it on Google Play">
        <img src="/assets/img/download-google-play.svg" aria-hidden="true">
      </a>
    </download-buttons>

    <p><a href="javascript:" @click.stop="dismissModal()">Click here to continue in your browser</a></p>
  </ion-content>
</template>

<script>
import { IonContent, IonHeader, IonToolbar, IonButtons, IonButton, IonIcon, modalController } from '@ionic/vue';
import { close } from 'ionicons/icons';
import { defineComponent } from 'vue';
import { store } from '@/store';

export default defineComponent({
  name: 'DownloadModal',
  components: { IonContent, IonHeader, IonToolbar, IonButtons, IonButton, IonIcon },
  setup() {
    return {
      close
    }
  },
  data() {
    return {
      sharedState: store.state,
    }
  },
  methods: {
    dismissModal() {
      modalController.dismiss();
    }
  },
  computed: {
    direction: function() { return ['ar','fa'].includes(this.sharedState.language) ? 'rtl' : 'ltr' }
  }
});
</script>

<style>
  .download-modal {
    --height: 18.5rem;
    --width: calc(100% - 1rem);
    --max-width: 24.5rem;
  }

  .download-modal ion-header {
    box-shadow: none;
  }

  .download-modal ion-toolbar {
    --border-width: 0 !important;
  }

  .download-modal .ion-page {
    background: var(--ion-color-primary);
  }

  .download-modal ion-content {
    --background: var(--ion-color-primary);
    --color: #fff;
    --padding-top: 0;
    text-align: center;
  }

  .download-modal ion-content > *:first-child {
    margin-block-start: 0;
  }

  .download-modal ion-content > * + * {
    margin-block-start: 2rem;
  }

  .download-modal ion-content > *:last-child {
    margin-block-end: 0;
  }

  .download-modal ion-content p {
    font-size: 1.3125rem;
  }

  .download-modal ion-content p a {
    color: #fff;
    font-size: 0.9375rem;
    text-decoration: none;
  }

  download-buttons {
    display: flex;
    gap: 1.25rem;
  }
</style>